import React, { ReactNode } from "react";
import styles from "./AppButton.module.scss";
import Spinner from "@/components/icons/Spinner";

export interface AppButtonProps {
  label: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  variant?: "primary" | "secondary" | "outlined" | "custom";
  disabled?: boolean;
  className?: string;
  loading?: boolean;
  icon?: ReactNode;
  textClassName?: string;
  iconIsAfter?: boolean;
}

const AppButton: React.FC<AppButtonProps> = ({
  label,
  onClick,
  type = "button",
  variant = "primary",
  disabled = false,
  className,
  loading = false,
  icon,
  textClassName,
  iconIsAfter,
}) => {
  const getButtonStyle = () => {
    switch (variant) {
      case "primary":
        return styles.primaryButton;
      case "custom":
        return styles.submitButton;
      case "secondary":
        return styles.secondaryButton;
      case "outlined":
        return styles.outlinedButton;
      default:
        return styles.primaryButton;
    }
  };

  return (
    <button
      className={`${styles.button} ${getButtonStyle()} h-10  ${className} ${loading ? styles.loading : ""} flex gap-2  cursor-pointer`}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {!iconIsAfter && icon && <span className={styles.icon}>{icon}</span>}
      <span
        className={`${styles.label} text-[14px] !font-medium ${loading ? styles.hidden : ""} ${textClassName}`}
      >
        {label}
      </span>
      {loading && (
        <span className={styles.spinner}>
          <Spinner />
        </span>
      )}
      {iconIsAfter && icon && <span className={styles.icon}>{icon}</span>}
    </button>
  );
};

export default AppButton;
